import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersImageComponent extends BaseComponent2 {
    public rootSelector = '.js_of_offers-image';

    public async onReloadComponentEvent(): Promise<void> {
        return;
    }
}
